import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatRegionSelector = createCustomElementWrapper('kat-region-selector', 'KatRegionSelector', {
    'maxHeight': 'max-height',
    'mobileLabel': 'mobile-label',
    'showClear': 'show-clear',
    'stateEmphasis': 'state-emphasis',
    'stateLabel': 'state-label',
}, {
    'onChange': 'change',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/region-selector.js
// module id = 1288
// module chunks = 0